import {useNavigation} from '@react-navigation/native';
import ProfileButton from 'components/atoms/profileButton';
import ProfilePhotoWithoutImage from 'components/atoms/ProfilePhotoWithoutImage';
import {useAuthStore, useUserStore} from 'contexts/StoreContext';
import {useTheme} from 'contexts/ThemeContext';
import {observer} from 'mobx-react';
import {Flows} from 'navigations/Screens';
import React, {useState} from 'react';
import {Image, Text, TouchableOpacity, View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

export interface ProfileWebProps {
  onChangePhotoPress: () => void;
}

const ProfileWeb = observer((props: ProfileWebProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const [isShown, setIsShown] = useState(false);

  const userStore = useUserStore();
  const authStore = useAuthStore();
  const navigation = useNavigation();

  const onLogOutPress = () => {
    authStore.signOut();
    navigation.navigate(Flows.authFlow as never);
    navigation.reset({
      index: 0,
      routes: [{name: Flows.authFlow as never}],
    });
  };

  const onDeletePress = () => {
    userStore.deleteUser();
    onLogOutPress();
  };

  const UserContent = (
    <View style={styles.userContent}>
      {userStore.user?.image ? (
        <Image style={styles.image} source={{uri: userStore.user?.image}} />
      ) : (
        <ProfilePhotoWithoutImage
          isBigPhoto={false}
          name={userStore.fullUserName}
          isPhotoOnTheHomeGreeting={false}
        />
      )}
      <View style={styles.textContainer}>
        <Text style={styles.fullName}>{userStore.fullUserName}</Text>
        <Text style={styles.email}>{userStore.user?.email}</Text>
      </View>
    </View>
  );

  const HiddenContent = (
    <View style={styles.hiddenContent}>
      {UserContent}
      <View style={styles.spacer} />
      <ProfileButton
        text={strings.profile.profilePhoto}
        image={theme.images.profilePhoto}
        onPress={props.onChangePhotoPress}
      />
      <ProfileButton
        text={strings.profile.logOut}
        image={theme.images.logout}
        onPress={onLogOutPress}
      />
      <View style={styles.bottomSpacer} />
      {userStore.isTeacherOrAdmin && (
        <ProfileButton
          text={strings.profile.deleteAccount}
          image={theme.images.trash}
          colorText={theme.colors.carnation}
          onPress={onDeletePress}
        />
      )}
    </View>
  );

  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={styles.touchableContainer}
        onPress={() => setIsShown(!isShown)}>
        {userStore.user?.image ? (
          <Image style={styles.image} source={{uri: userStore.user?.image}} />
        ) : (
          <ProfilePhotoWithoutImage
            isBigPhoto={false}
            name={userStore.fullUserName}
            isPhotoOnTheHomeGreeting={false}
          />
        )}
        <Image style={styles.arrowImage} source={theme.images.downArrow} />
      </TouchableOpacity>
      {isShown && HiddenContent}
    </View>
  );
});

export default ProfileWeb;
